import { render } from "./ReportCard.vue?vue&type=template&id=36805659&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"

import "./ReportCard.vue?vue&type=style&index=0&id=36805659&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36805659"]])

export default __exports__